export default {
  kitchenIsland: 'kitchen-island',
  style: 'style',
  sink: 'sink',
  plan: 'plan',
  cutouts: 'cut-outs',
};
